import React from 'react'
import { Switch, Row, Col } from 'antd'

class SwitchForm extends React.Component {
  getFiles = () => {
    const { columns } = this.props
    return columns.map((v, idx) => (
      <Col key={'Col' + idx} span={24} style={{ marginTop: '10px' }}>
        <div key={'div' + idx}>
          <span key={'span' + idx} className={'zrs-label'}>
            {v.label}：
          </span>
          {v.label !== '时长结束前提醒' && (
            <Switch
              key={'switch' + idx}
              style={{ float: 'right' }}
              label={v.label}
              checked={v.checked}
              disabled={v.disabled}
              content={v.content}
              onChange={v.handleChange}
            />
          )}
        </div>
        {v.label === '每日使用限时' ||
        v.label === '每个账号限领一次' ||
        v.label === '时长结束前提醒'
          ? v.checked
            ? v.content
            : null
          : !v.checked
          ? v.content
          : null}
      </Col>
    ))
  }

  render() {
    return (
      <div>
        <Row gutter={24} type="flex" justify="center" align="top">
          {this.getFiles()}
        </Row>
      </div>
    )
  }
}

export default SwitchForm



// WEBPACK FOOTER //
// ./src/containers/CardManage/components/switchForm.js